import { Component, HostListener, OnInit, Input } from '@angular/core';
import { TenantDeparmentDto } from 'app/api/models/tenant/tenantDeparmentDto';
import { TenantFolderDto } from 'app/api/models/tenant/tenantFolderDto';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'app-tenant-departments',
  templateUrl: './tenant-departments.component.html',
  styleUrl: './tenant-departments.component.scss',
  standalone: false,
})
export class TenantDepartmentsComponent implements OnInit {
  constructor(private tenantService: TenantsService) {}

  @Input({ required: true }) tenantId!: string;

  deleteConfirmation: TenantDeparmentDto | null = null;

  departments: TenantDeparmentDto[] = [];
  newDepartmentText: string = '';
  innerWidth = 0;
  ngOnInit(): void {
    this.refreshData();
    this.innerWidth = window.innerWidth;
  }
  @HostListener('window:resize')
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  addDepartment() {
    if (this.newDepartmentText.trim()) {
      let newDepartment = new TenantDeparmentDto();
      newDepartment.name = this.newDepartmentText;
      this.tenantService
        .addTenantDepartment(this.tenantId, newDepartment)
        .pipe(untilDestroyed(this))
        .subscribe((x) => {
          this.refreshData();
          this.newDepartmentText = '';
        });
    }
  }

  refreshData() {
    this.tenantService
      .getAllTenantsDepartments(this.tenantId)
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        this.departments = x;
      });
  }

  handleDeleteClick(department: TenantDeparmentDto) {
    this.tenantService
      .deleteTenantDepartment(this.tenantId, department.id!)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.refreshData();
      });
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
  }
}
